// extracted by mini-css-extract-plugin
export var active = "style-module--active--92997";
export var arrow = "style-module--arrow--875c0";
export var arrowContainer = "style-module--arrowContainer--b087a";
export var dot = "style-module--dot--5cc03";
export var number = "style-module--number--e96be";
export var numberContainer = "style-module--numberContainer--eb31a";
export var pager = "style-module--pager--81328";
export var status = "style-module--status--37c8d";
export var ui = "style-module--ui--ee3c4";